<template>
  <div class="award_content" v-if="data.style" :style="'position: relative;background-color:'+data.style.backgroundColor">
    <div class="award_top" :style="'position: relative;background-image:url('+oss+data.style.backgroundImage+');'">
      <div class="title text-ac s_font_b fz-35 p-t-20 p-l-10 p-r-10" :style="'color:'+data.style.titleColor">{{data.params.copyWriting}}</div>
      <div class="award_main">
        <img :src="oss+data.params.icon" alt="">
      </div>
      <div class="award_btn" v-if="data.params&&data.params.btnKey.length">
        <div v-if="data.params.btnKey.indexOf('cloud')!=-1"><img src="@/assets/images/scan/store_icon.png" alt=""> 云店商城</div>
        <div v-if="data.params.btnKey.indexOf('center')!=-1"><img src="@/assets/images/scan/center_icon.png" alt="">会员中心</div>
      </div>
      <div class="ranking ">
        <div class="rankTabs s_flex_center s_cfff fz-16 m-b-20" v-if="data.params&&data.params.rankingKey.length">
          <div class="tabsItem flex_1 text-ac" v-if="data.params.rankingKey.indexOf('red')!=-1">红包排行榜</div>
          <div class="tabsItem flex_1 text-ac" v-if="data.params.rankingKey.indexOf('point')!=-1">积分排行榜</div>
        </div>
        <div class="rankList s_bf s_bor10 p-t-10 p-l-20 p-b-10">
          <div class="item s_flex_center s_c999 fz-12 m-b-15">
            <div class="flex_1 ">排行</div>
            <div class="flex_3">昵称</div>
            <div class="flex_2 ">红包总收入</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_one.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿01</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_two.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿02</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_tree.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿03</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">04</div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿04</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">05</div>
            <div class="flex_3 s_c1212 fz-14"> <img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">
              幸运儿05</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">06</div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿06</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  name: "notWinning",
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.award_content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .award_top {
    height: 667px;
    overflow: visible;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    .award_main {
      height: 300px;
      width: 230px;
      position: absolute;
      top: 135px;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 100%;
      }
    }
    .award_btn {
      width: 320px;
      height: 48px;
      z-index: 1;
      background: #e2152d;
      border-radius: 48px;
      position: absolute;
      top: 560px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
          >div:nth-child(2){
           &::before {
        content: "";
        width: 32px;
        height: 32px;
        background-image: url("../../../../../../../assets/images/scan/line.png");
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      }
      > div {
        flex: 1;
        text-align: center;
        line-height: 48px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fee6ac;
        img {
          width: 21px;
          height: 21px;
          margin-right: 10px;
        }
      }
    }
    .ranking {
      position: absolute;
      top: 435px;
      width: 300px;
      left: 50%;
      transform: translateX(-50%);
      .tabsItem:nth-child(2) {
        position: relative;
        &::before {
          content: "";
          width: 0;
          height: 0;
          border: 10px solid;
          position: absolute;
          border-color: transparent transparent #fff;
          bottom: -20px;
          right: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>